import FeedbackReport from './FeedbackReport';

export default FeedbackReport;
